module.exports = __webpack_public_path__ + "img/offline.0ff84f17.svg";